export const productEmbroideringData = (selectedVariantId, variantTitle)=>{
    let object = {
        embroidery_product: {
            id: '',
            title: '',
            price: ''
        },
        current_variant: {
            id: '',
            title: '',
            price: ''
        },
        product: {
            id: '',
            title: ''
        },
        text_configurations: [],
        personalizations: [],
        images: [],
        placements: [],
        colors: [],
        test_image_personalization: ''
    };
    try {
        const dataElement = document.getElementById('product-embroidering-data');
        if (dataElement && dataElement.textContent) {
            object = JSON.parse(dataElement.textContent);
            console.log('Loaded product embroidering data:', object);
            if (object && selectedVariantId) {
                object.current_variant.id = selectedVariantId.toString();
            }
            if (object && variantTitle) {
                object.current_variant.title = variantTitle;
            }
        }
    } catch (e) {
        console.error('Error loading product embroidering data:', e);
    }
    return object;
};
